import { render, staticRenderFns } from "./PageInfoPreRegis.vue?vue&type=template&id=77d095ea&scoped=true"
import script from "./PageInfoPreRegis.vue?vue&type=script&lang=js"
export * from "./PageInfoPreRegis.vue?vue&type=script&lang=js"
import style0 from "./PageInfoPreRegis.vue?vue&type=style&index=0&id=77d095ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d095ea",
  null
  
)

export default component.exports